import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { pole } from '../utils';
import { selectStyle } from '../ui';

const API = process.env.REACT_APP_API_URL || '/api';

// Výběr výjezdu téhož technika ze stejného dne, u kterého je započtena společná cesta.
// value = id tiketu ('' = cesta se zapisuje u tohoto tiketu).
export default function VyberCesty({ datum, technikId, kromeTiketId, value, onChange }) {
  const [moznosti, setMoznosti] = useState([]);
  const [chyba, setChyba] = useState(false);

  useEffect(() => {
    if (!datum) { setMoznosti([]); return; }
    const params = { datum };
    if (technikId) params.technik_id = technikId;
    if (kromeTiketId) params.krome_tiket_id = kromeTiketId;
    axios.get(`${API}/vyjezdy/pro-cestu`, { params })
      .then(r => { setMoznosti(pole(r.data)); setChyba(false); })
      .catch(() => { setMoznosti([]); setChyba(true); });
  }, [datum, technikId, kromeTiketId]);

  const cas = iso => new Date(iso).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' });
  const vybrana = moznosti.find(m => String(m.tiket_id) === String(value));
  const vybranaChybi = value && !moznosti.some(m => String(m.tiket_id) === String(value));

  return (
    <>
      <select style={selectStyle} value={value} onChange={e => onChange(e.target.value)}>
        <option value="">Ne – cesta se zapíše u tohoto tiketu</option>
        {vybranaChybi && <option value={value}>tiket č. {value}</option>}
        {moznosti.map(m => (
          <option key={m.tiket_id} value={m.tiket_id}>
            {m.obj} – {m.provozovna_nazev}{m.provozovna_mesto ? `, ${m.provozovna_mesto}` : ''} · příjezd {cas(m.prijezd_at)}
            {m.odkazuje_na_tento ? ' · převede se na něj cesta' : !m.cesta_vyplnena ? ' · cesta zatím nevyplněna' : ''}
          </option>
        ))}
      </select>
      {vybrana && !vybrana.cesta_vyplnena && !vybrana.odkazuje_na_tento && (
        <div style={{ fontSize: '13px', color: '#92400e', background: '#fef3c7', borderRadius: '6px', padding: '6px 10px', marginTop: '6px' }}>
          U vybraného výjezdu ({vybrana.obj}) zatím není cesta vyplněná. Nezapomeňte ji tam doplnit, jinak se cesta nezapočte nikde.
        </div>
      )}
      {chyba && <div style={{ fontSize: '12px', color: '#b91c1c', marginTop: '4px' }}>Nepodařilo se načíst výjezdy.</div>}
      {!chyba && moznosti.length === 0 && !value && (
        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>V tento den nemáte jiný výjezd, u kterého by šla cesta započítat.</div>
      )}
    </>
  );
}
